import { Component, OnInit } from '@angular/core';
import { Instance, InstanceService } from '../instance.service';
import { AuthService } from '../auth.service';
import { PageEvent } from '@angular/material/paginator';
import { PageResponse } from '../base-capacitor-http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'instance',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './instance.component.html',
  styleUrls: ['./instance.component.css']
})

export class InstanceComponent implements OnInit {

  page: PageResponse<Instance>;
  pageSize: number = 10;
  activeInstance: number;
  modal: boolean = false;
  toast: boolean = false;
  selectedInstance: number = 0;
  modalInstance: Instance;
  toastTitle: string = '';
  toastMessage: string = '';
  // Type icons (using emojis for simplicity)
  typeIcons = {
    'Database': '🗄️',
    'Compute': '💻',
    'Storage': '💾',
    'Cache': '⚡'
  };

  constructor(private instanceService: InstanceService, private authService: AuthService) {

  }

  showModal() {
    this.modal = true;
  }

  hideModal() {
    this.modal = false;
  }

  showToast(title: string, message: string) {
    this.toastTitle = title;
    this.toastMessage = message;
    this.toast = true;
    setTimeout(() => {
      this.toast = false;
      this.toastTitle = '';
      this.toastMessage = '';

    }, 5000);
  }
  hideToast() {
    this.toast = false;
  }

  async addInstance() {
    if (this.page.totalItems > 1) {
      return;
    }
    const authResponse = await this.instanceService.createInstance(this.modalInstance.name);
    if (authResponse) {
      await this.authService.storeAuthToken(authResponse);
      this.modalInstance = new Instance();
      this.modal = false;
      this.showToast('Insatnce added', 'Instance has been added.');
    }
  }

  async removeInstance() {

  }

  async toggleDropdown(instanceId: number) {
    if (this.selectedInstance === instanceId) {
      this.selectedInstance = null;
      return;
    }
    this.selectedInstance = instanceId;
  }

  async handleInstanceAction(index: number, action: string) {
    const instance = this.page.data[index];
    let update: Instance;

    switch (action) {
      case 'switch':
        const authResponse = await this.instanceService.switchInstance(instance.id);
        if (authResponse) {
          //this.authService.storeAuthToken(authResponse);
          this.authService.updateAuthState(authResponse);
          this.activeInstance = instance.id;
          this.showToast('Instance switched', 'ok');
        }
        break;
      case 'start':
        instance.status = 'ACTIVE';
        update = await this.instanceService.updateInstance(instance);
        if (update) {
          this.page.data[index] = update;
          this.showToast('Instance Updated', 'Instance status has been updated');
        }
        break;
      case 'stop':
        instance.status = 'STOPPED';
        update = await this.instanceService.updateInstance(instance);
        if (update) {
          this.page.data[index] = update;
          this.showToast('Instance Updated', 'Instance status has been updated');
        }
        break;

      case 'delete':
        const deleteResult = await this.instanceService.deleteInstance(instance.id);
        if (deleteResult) {
          this.page.data.splice(index, 1);
          this.showToast('Deleted Instance', 'Instance ' + instance.name + ' has been removed');
        }
        break;
      default:
        break;
    }

  }

  async switchInstance(instanceId: number) {
    const authResponse = await this.instanceService.switchInstance(instanceId);
    if (authResponse) {
      await this.authService.storeAuthToken(authResponse);
      const instance = this.page.data.find(instance => instance.id === instanceId);
      this.showToast("Instance switched", "Switched to instance " + instance.name);
    }
  }


  async handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.page = await this.instanceService.getUserInstances(e.pageIndex, this.pageSize, null);
  }




  async ngOnInit(): Promise<void> {
    this.modalInstance = new Instance();
    this.page = new PageResponse();
    this.page = await this.instanceService.getUserInstances(0, this.pageSize, null);
    this.activeInstance = await this.authService.getActiveInstance() || 0;
  }

}
